export default "__VITE_ASSET__868c5c7c__"